module.exports = __webpack_public_path__ + "media/images/swifticons/squarelist-cc7f78a2200ec7f7c48dbe89fb807823.svg";